const AgentsFactoryActionTypes = {
  AGENTS_FACTORY_SIGNUP_REQUEST: 'AGENTS_FACTORY_SIGNUP_REQUEST',
  AGENTS_FACTORY_SIGNUP_SUCCESS: 'AGENTS_FACTORY_SIGNUP_SUCCESS',
  AGENTS_FACTORY_SIGNUP_FAILURE: 'AGENTS_FACTORY_SIGNUP_FAILURE',
  AGENTS_FACTORY_CREATE_REQUEST: 'AGENTS_FACTORY_CREATE_REQUEST',
  AGENTS_FACTORY_CREATE_SUCCESS: 'AGENTS_FACTORY_CREATE_SUCCESS',
  AGENTS_FACTORY_CREATE_FAILURE: 'AGENTS_FACTORY_CREATE_FAILURE',
  AGENTS_FACTORY_CHANGE_STATUS_REQUEST: 'AGENTS_FACTORY_CHANGE_STATUS_REQUEST',
  AGENTS_FACTORY_CHANGE_STATUS_SUCCESS: 'AGENTS_FACTORY_CHANGE_STATUS_SUCCESS',
  AGENTS_FACTORY_CHANGE_STATUS_FAILURE: 'AGENTS_FACTORY_CHANGE_STATUS_FAILURE',
  AGENTS_FACTORY_IMPROVE_TEXT_WITH_AI_REQUEST: 'AGENTS_FACTORY_IMPROVE_TEXT_WITH_AI_REQUEST',
  AGENTS_FACTORY_IMPROVE_TEXT_WITH_AI_SUCCESS: 'AGENTS_FACTORY_IMPROVE_TEXT_WITH_AI_SUCCESS',
  AGENTS_FACTORY_IMPROVE_TEXT_WITH_AI_FAILURE: 'AGENTS_FACTORY_IMPROVE_TEXT_WITH_AI_FAILURE',
  AGENTS_FACTORY_SET_IMPROVED_TEXT: 'AGENTS_FACTORY_SET_IMPROVED_TEXT',
  AGENTS_FACTORY_IMPROVE_TEXT_WITH_AI_LOADING: 'AGENTS_FACTORY_IMPROVE_TEXT_WITH_AI_LOADING',
  AGENTS_FACTORY_CREATE_DATABASE_REQUEST: 'AGENTS_FACTORY_CREATE_DATABASE_REQUEST',
  AGENTS_FACTORY_CREATE_DATABASE_SUCCESS: 'AGENTS_FACTORY_CREATE_DATABASE_SUCCESS',
  AGENTS_FACTORY_CREATE_DATABASE_FAILURE: 'AGENTS_FACTORY_CREATE_DATABASE_FAILURE',
};

export { AgentsFactoryActionTypes };
